import request from '@/util/request'

// 随队官员列表（分页）
export const getPersonPage = (data) => {
  return request({
    url: `/api/register/person/page`,
    method: 'GET',
    data
  })
}

// 随队官员列表（不分页）
export const getPersonList = (data) => {
  return request({
    url: `/api/register/person/list`,
    method: 'GET',
    data
  })
}

// 随队官员导出列表（全赛事）
export const getPersonExport = (data) => {
  return request({
    url: `/api/register/person/exportList`,
    method: 'GET',
    data,
    responseType: 'blob'
  })
}

// 新增/修改随队官员
export const personEdit = (data) => {
  return request({
    url: `/api/register/person/edit`,
    method: 'POST',
    data
  })
}

// 随队官员详情
export const getPersonInfo = (id) => {
  return request({
    url: `/api/register/person/info/${id}`,
    method: 'GET',
  })
}

// 删除随队官员
export const personDel = (data) => {
  return request({
    url: `/api/register/person/del`,
    method: 'POST',
    data
  })
}
